import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import TitlePage from 'components/TituloPage';
import DetalheRequisicao from 'containers/RequerimentoDetalhe';
import { pesquisarProtocolo, requerimentos, requerimentosListarContribuinte } from 'routes/paths';
import { fetchAdicionarJustificativa, fetchDetalharFormularioPorId } from 'store/fetchActions/fetchFormulario';
import { ID_REQUERIMENTO_DETALHAR, STATUS_REQUERIMENTO } from 'utils/consts';
import { ENUM_TIPO_PERFIL } from 'utils/permissao';
import { formatterRequerimentoBackToFront } from 'utils/formatter/requerimento';
import {
  verificarUsuarioAlterarStatus,
  handleAlterarStatusAtendente,
  handleAlterarStatusAtendenteSetorial,
} from './Detalhar';
import * as S from '../styles';

export default function PageDetalharRequerimento() {
  const dispatch = useDispatch();

  const dadosExibirDetalhar = useSelector(state => state.formulario.dadosExibirDetalhar);
  const user = useSelector(state => state.sefaz.userProfile);
  const atendenteLogado = useSelector(state => state.atendente.atendenteLogado);

  React.useEffect(() => {
    if (verificarUsuarioAlterarStatus(atendenteLogado, dadosExibirDetalhar?.status?.identificador)) {
      const objetoJustificativa = {
        justificativa: 'Iniciando Atendimento',
        formularioId: dadosExibirDetalhar?.id,
        atendenteId: atendenteLogado?.id,
        isAtendente: true,
        statusId: STATUS_REQUERIMENTO.EM_ATENDIMENTO.id,
        setorId: dadosExibirDetalhar?.setorId || null,
      };

      if (atendenteLogado.isSetorial) {
        dispatch(
          handleAlterarStatusAtendenteSetorial(atendenteLogado, dadosExibirDetalhar, STATUS_REQUERIMENTO.EM_ATENDIMENTO)
        );
      } else {
        dispatch(fetchAdicionarJustificativa(objetoJustificativa)).then(() => {
          dispatch(handleAlterarStatusAtendente(dadosExibirDetalhar, STATUS_REQUERIMENTO.EM_ATENDIMENTO));
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, atendenteLogado, dadosExibirDetalhar]);

  React.useEffect(() => {
    const idDetalhar = localStorage.getItem(ID_REQUERIMENTO_DETALHAR);
    if (!dadosExibirDetalhar.localizador && idDetalhar) {
      localStorage.removeItem(ID_REQUERIMENTO_DETALHAR);
      dispatch(fetchDetalharFormularioPorId(idDetalhar));
    }
    // eslint-disable-next-line
  }, [dispatch]);

  const getBackPage = () => {
    if (!user) return pesquisarProtocolo;
    if (user?.profile !== ENUM_TIPO_PERFIL.CONTRIBUINTE) return requerimentos;
    if (user?.profile === ENUM_TIPO_PERFIL.CONTRIBUINTE) return requerimentosListarContribuinte;
    return pesquisarProtocolo;
  };

  return (
    <S.Contain className="boxShadow">
      <TitlePage textTitle="Detalhe do Requerimento" backPage={getBackPage()} />
      {dadosExibirDetalhar?.id && <DetalheRequisicao dados={formatterRequerimentoBackToFront(dadosExibirDetalhar)} />}
    </S.Contain>
  );
}
